import { useMemo } from 'react';
import { Select, SelectProps } from '@mantine/core';
import { SUBAWARDEE_INFO } from '../../config/initiativeLeadsMapping';

export type AdminSubawardeeFilterSelectProps = Omit<SelectProps, 'data'> & {
  value: string | null;
  onChange: (subawardee: string | null) => void;
};

/**
 * Subawardee filter (friendly name → X-Selected-Group). Use inside a filters row with other Selects.
 */
export function AdminSubawardeeFilterSelect({
  value,
  onChange,
  disabled,
  style,
}: AdminSubawardeeFilterSelectProps) {
  const data = useMemo(
    () =>
      [...SUBAWARDEE_INFO]
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
        .map((s) => ({
          value: s.id,
          label: s.displayName,
        })),
    []
  );

  return (
    <Select
      label="Filter by Subawardee"
      placeholder="Select subawardee"
      required
      searchable
      clearable={false}
      data={data}
      value={value}
      onChange={onChange}
      disabled={disabled}
      maxDropdownHeight={320}
      style={style ?? { flex: 1, minWidth: 200 }}
      styles={{
        label: { marginBottom: '8px' },
        root: {
          '@media (max-width: 768px)': {
            width: '100%',
            minWidth: 'auto',
          },
        },
      }}
    />
  );
}
